<template>
  <header class="page-head tech-parallax-header">
    <div class="parallax-container">
      <div class="parallax-bg"></div>
      <div class="overlay"></div>
      <div class="circuit-layer"></div>
      <div class="data-flow">
        <div class="data-line"></div>
        <div class="data-line"></div>
        <div class="data-line"></div>
        <div class="data-line"></div>
      </div>
      <div class="floating-elements">
        <div class="dot" v-for="n in 20" :key="n"></div>
      </div>
    </div>

    <!-- Overlay content -->
    <div class="header-wrapper">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <!-- <ol class="breadcrumb">
              <li><a href="index.html">Home</a></li>
              <li class="active">About Us</li>
            </ol> -->
            <!-- end of /.breadcrumb -->
          </div>
        </div>
      </div>
      <!-- /.container -->
    </div>
    <!-- /.header-wrapper -->
  </header>
</template>

<script>
export default {
  name: "HeaderAboutSection",
};
</script>

<style scoped>
/* Tech Parallax Header Styles */
.tech-parallax-header {
  position: relative;
  overflow: hidden;
  height: 157px;
}

.parallax-container {
  /* position: absolute; */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 1;
}

.parallax-bg {
  position: absolute;
  width: 100%;
  height: 120%;
  background-image: url("~@/assets/img/tech-parallax-bg.png");
  background-position: center -3000px;
  background-size: 1894px auto;
  background-attachment: fixed;
  z-index: 1;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    rgba(0, 18, 36, 0.6) 0%,
    rgba(9, 9, 121, 0.2) 50%,
    rgba(0, 18, 36, 0.6) 100%
  );
  z-index: 2;
}

.circuit-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(
      circle at 20% 30%,
      rgba(0, 162, 255, 0.1) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 80% 70%,
      rgba(0, 255, 135, 0.1) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 50% 50%,
      rgba(255, 0, 150, 0.1) 0%,
      transparent 50%
    );
  z-index: 3;
}

.data-flow {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 4;
}

.data-line {
  position: absolute;
  width: 200px;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(0, 255, 255, 0.8) 50%,
    transparent 100%
  );
  animation: dataFlow 4s linear infinite;
}

.data-line:nth-child(1) {
  top: 20%;
  left: -200px;
  animation-delay: 0s;
}

.data-line:nth-child(2) {
  top: 40%;
  left: -200px;
  animation-delay: 1s;
}

.data-line:nth-child(3) {
  top: 60%;
  left: -200px;
  animation-delay: 2s;
}

.data-line:nth-child(4) {
  top: 80%;
  left: -200px;
  animation-delay: 3s;
}

.floating-elements {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
}

.dot {
  position: absolute;
  width: 4px;
  height: 4px;
  background: rgba(0, 255, 255, 0.8);
  border-radius: 50%;
  animation: float 6s ease-in-out infinite;
  box-shadow: 0 0 10px rgba(0, 255, 255, 0.5);
}

.dot:nth-child(1) {
  top: 10%;
  left: 10%;
  animation-delay: 0s;
}
.dot:nth-child(2) {
  top: 20%;
  left: 20%;
  animation-delay: 0.5s;
}
.dot:nth-child(3) {
  top: 30%;
  left: 30%;
  animation-delay: 1s;
}
.dot:nth-child(4) {
  top: 40%;
  left: 40%;
  animation-delay: 1.5s;
}
.dot:nth-child(5) {
  top: 50%;
  left: 50%;
  animation-delay: 2s;
}
.dot:nth-child(6) {
  top: 60%;
  left: 60%;
  animation-delay: 2.5s;
}
.dot:nth-child(7) {
  top: 70%;
  left: 70%;
  animation-delay: 3s;
}
.dot:nth-child(8) {
  top: 80%;
  left: 80%;
  animation-delay: 3.5s;
}
.dot:nth-child(9) {
  top: 15%;
  left: 85%;
  animation-delay: 4s;
}
.dot:nth-child(10) {
  top: 25%;
  left: 75%;
  animation-delay: 4.5s;
}
.dot:nth-child(11) {
  top: 35%;
  left: 65%;
  animation-delay: 5s;
}
.dot:nth-child(12) {
  top: 45%;
  left: 55%;
  animation-delay: 5.5s;
}
.dot:nth-child(13) {
  top: 55%;
  left: 45%;
  animation-delay: 0.2s;
}
.dot:nth-child(14) {
  top: 65%;
  left: 35%;
  animation-delay: 0.7s;
}
.dot:nth-child(15) {
  top: 75%;
  left: 25%;
  animation-delay: 1.2s;
}
.dot:nth-child(16) {
  top: 85%;
  left: 15%;
  animation-delay: 1.7s;
}
.dot:nth-child(17) {
  top: 5%;
  left: 50%;
  animation-delay: 2.2s;
}
.dot:nth-child(18) {
  top: 95%;
  left: 50%;
  animation-delay: 2.7s;
}
.dot:nth-child(19) {
  top: 50%;
  left: 5%;
  animation-delay: 3.2s;
}
.dot:nth-child(20) {
  top: 50%;
  left: 95%;
  animation-delay: 3.7s;
}

@keyframes dataFlow {
  0% {
    left: -200px;
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    left: 100%;
    opacity: 0;
  }
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0px) scale(1);
    opacity: 0.7;
  }
  50% {
    transform: translateY(-20px) scale(1.2);
    opacity: 1;
  }
}

/* Header wrapper overlay */
.header-wrapper {
  position: relative;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.45);
  padding: 65px 0px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .parallax-bg {
    background-size: 1200px auto;
    background-position: center -50px;
  }

  .data-line {
    width: 150px;
  }

  .dot {
    width: 3px;
    height: 3px;
  }
}

@media (max-width: 480px) {
  .parallax-bg {
    background-size: 800px auto;
    background-position: center -30px;
  }

  .data-line {
    width: 100px;
  }

  .dot:nth-child(n + 5) {
    display: none;
  }
}
</style>
